import { LegalShell, Sec } from '../components/LegalShell';

/**
 * Condiciones del Servicio de ÁGORA (públicas). Requeridas por la pantalla de
 * consentimiento OAuth de Google. Borrador institucional: validar con el área
 * legal antes de un uso definitivo.
 */
export function TerminosPage() {
  return (
    <LegalShell
      titulo="Condiciones del Servicio"
      actualizado="21 de julio de 2026"
      otro={{ href: '/privacidad', texto: 'Política de Privacidad' }}
      intro="Estas condiciones regulan el uso de ÁGORA, la plataforma de innovación participativa operada por Grupo InteligencIA. Al acceder o usar la plataforma, aceptás estas condiciones."
    >
      <Sec titulo="1. Descripción del servicio">
        <p>
          ÁGORA permite a una institución conducir procesos participativos: capturar aportes de
          personas y grupos, organizarlos y convertirlos en propuestas de proyecto trazables,
          donde cada afirmación puede regresar a su evidencia.
        </p>
      </Sec>

      <Sec titulo="2. Cuentas y acceso">
        <p>
          Podés acceder con correo y contraseña, con tu cuenta de Google o con el código y PIN de
          una sala presencial. Sos responsable de mantener la confidencialidad de tus
          credenciales y de la actividad realizada bajo tu cuenta.
        </p>
      </Sec>

      <Sec titulo="3. Uso aceptable">
        <p>Al usar ÁGORA, te comprometés a no:</p>
        <ul className="list-disc pl-5">
          <li>Suplantar a otras personas ni falsear tu identidad.</li>
          <li>Cargar contenido ilícito, difamatorio o que vulnere derechos de terceros.</li>
          <li>
            Intentar acceder sin autorización a datos de otros procesos o instituciones, ni
            interferir con la seguridad de la plataforma.
          </li>
        </ul>
      </Sec>

      <Sec titulo="4. Contenido y coautoría">
        <p>
          Los aportes que hacés en un proceso se registran con tu autoría como parte del acta.
          El contenido y los resultados del proceso pertenecen a la institución responsable, que
          los administra conforme a su normativa. ÁGORA reconoce la coautoría de quienes
          participan.
        </p>
      </Sec>

      <Sec titulo="5. Asistencia de inteligencia artificial">
        <p>
          La plataforma puede usar inteligencia artificial para asistir la organización y
          redacción de contenidos. Toda salida asistida cita la evidencia que la respalda y lo no
          respaldado se marca como tal; la decisión final es siempre humana.
        </p>
      </Sec>

      <Sec titulo="6. Disponibilidad">
        <p>
          Procuramos un servicio continuo, pero puede haber interrupciones por mantenimiento o
          causas fuera de nuestro control. El servicio se ofrece «tal cual», sin garantías
          implícitas de disponibilidad ininterrumpida.
        </p>
      </Sec>

      <Sec titulo="7. Limitación de responsabilidad">
        <p>
          En la medida permitida por la ley, Grupo InteligencIA no será responsable por daños
          indirectos o incidentales derivados del uso o la imposibilidad de uso de la plataforma.
        </p>
      </Sec>

      <Sec titulo="8. Terminación">
        <p>
          La institución responsable puede suspender o dar de baja cuentas que incumplan estas
          condiciones. Podés dejar de usar el servicio en cualquier momento.
        </p>
      </Sec>

      <Sec titulo="9. Cambios">
        <p>
          Podemos actualizar estas condiciones. Publicaremos la versión vigente en esta página
          con su fecha de última actualización.
        </p>
      </Sec>

      <Sec titulo="10. Ley aplicable y contacto">
        <p>
          Estas condiciones se rigen por las leyes de la República de Guatemala. Para consultas:{' '}
          <span className="text-content">legal@inteligencia.com.gt</span>.
        </p>
      </Sec>
    </LegalShell>
  );
}
